var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callParticipant"},[_c('VehicleBrief',{attrs:{"label":_vm.vehicle.vehicleLabel,"sizeClass":"h6","showLink":false,"removeGroupCall":true}}),_c('span',{staticClass:"endpointStatus",class:_vm.status},[_vm._v(_vm._s(_vm.$t('voip.group_call.status.'+ _vm.status)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }